import { connect } from 'react-redux'
import { UpdateGroupForm as Form } from './UpdateGroupForm'
import { AppStateType } from '../../reducers'
import { selectGroup } from '../../selectors/group'
import { selectAreaWritable } from '../../selectors/auth'
import { AREA_CONSTANTS } from '../../services/auth'

const mapStateToProps = (state: AppStateType) => ({
  group: selectGroup(state),
  editable: selectAreaWritable(state, { area: AREA_CONSTANTS.SETTINGS_GROUP }),
})

export const UpdateGroupForm = connect(mapStateToProps)(Form)
